import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '../../../Components/Header';
import './Setting.scss';
import { useGameReducer } from '../../../Store';
import { FooterMenu } from '../../../Components/FooterMenu';
import { UserActions } from '../../../Store/Actions';

export const ManagerSetting = () => {
  const navigate = useNavigate();
  const redirect = (url) => {
    navigate(url);
  };

  const gameReducer = useGameReducer();

  useEffect(() => {
    if (gameReducer.token == null) {
      navigate('/Login');
    }
  }, [gameReducer.token]);


  const logout = () => {
    UserActions.logout();
  };

  return (
    <div className='agent_layout'>
      <Header name={'Setting'} />
      <div className='agent_body'>
        <div className='game_details_box'>
          <div className='game_details_box_inner center'>
            <div className='details_box_btn border_1 w_70' onClick={() => redirect('Language')}>
              <span className='btn_text wheat '>Language</span>
            </div>
          </div>
          <div className='game_details_box_inner center'>
            <div className='details_box_btn border_1 w_70' onClick={() => redirect('AdminChangepassword')}>
              <span className='btn_text wheat '>Change Password</span>
            </div>
          </div>
          <div className='game_details_box_inner center'>
            <div className='details_box_btn border_1 w_70' onClick={() => logout()}>
              <span className='btn_text wheat '>Logout</span>
            </div>
          </div>
        </div>
      </div>
      <FooterMenu isManager={true}/>
    </div>
  );
};
